<template>
  <div>
    <nav>
      <ul class="pager">
        <li class="previous">
          <router-link :to="{name: 'client_dashboard', client_id: $route.params.client_id}">
            <span aria-hidden="true">&larr;</span> Client dashboard
          </router-link>
        </li>
      </ul>
    </nav>

    <div class="jumbotron">
      <h1>
        {{currentClient.display_name}}
      </h1>

      <h2>
        <router-link :to="{name: 'va_drug_chart', client_id: $route.params.client_id}">
          VA/Drug Chart
        </router-link>
        <a href=""></a>
      </h2>

      <h2 v-if="currentClient.is_fonterra_client">
        <router-link :to="{name: 'fonterra_report', client_id: $route.params.client_id}">
          Cooperative Difference Wellbeing Report
        </router-link>
      </h2>

      <h2>
        <router-link :to="{name: 'drug_chart', client_id: $route.params.client_id}">
          GF Drug Chart
        </router-link>
        <a href=""></a>
      </h2>
      <h2>
        <router-link :to="{name: 'drug_combinations', client_id: $route.params.client_id}">
          Drug Combinations
        </router-link>
        <a href=""></a>
      </h2>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'ReportsPage',
  created ()
  {
    if (!this.currentClient)
    {
      this.getClient(this.$route.params.client_id)
    }
  },
  methods: {
    ...mapActions('client', ['getClient']),
  },
  computed: {
    ...mapState('client', ['currentClient']),
  }
}
</script>
